// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = module.exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.clickable[data-v-22ba47ca] \n{\n\tcursor: pointer;\n}\n.appointment-info[data-v-22ba47ca]\n{\n\tbackground-color: grey !important;\n\theight: 10px\n}\n.selected-background[data-v-22ba47ca]\n{\n\tbackground-color: #e5ffe5\n}\n.has-background-subbing[data-v-22ba47ca]\n{\n\tbackground-color: hsl(48, 100%, 80%)\n}\n", ""]);
